export default __webpack_public_path__ + "img/golf.fb552f.svg";